// `tnum` gives fixed-width digits so columns of figures line up and a changing
// KPI does not shift its own width. Applied to the heading variants because those
// are what carry numbers in this app.
const tabular = {
  fontFeatureSettings: '"tnum" 1, "lnum" 1',
  fontVariantNumeric: 'tabular-nums lining-nums' as const
};

export default {
  h1: {
    fontWeight: 700,
    fontSize: 34,
    letterSpacing: '-0.8px',
    lineHeight: 1.15,
    ...tabular
  },
  h2: {
    fontWeight: 700,
    fontSize: 28,
    letterSpacing: '-0.6px',
    lineHeight: 1.2,
    ...tabular
  },
  h3: {
    fontWeight: 700,
    fontSize: 23,
    letterSpacing: '-0.45px',
    lineHeight: 1.25,
    ...tabular
  },
  h4: {
    fontWeight: 600,
    fontSize: 19,
    letterSpacing: '-0.3px',
    lineHeight: 1.3,
    ...tabular
  },
  h5: {
    fontWeight: 600,
    fontSize: 16,
    letterSpacing: '-0.15px',
    lineHeight: 1.4,
    ...tabular
  },
  h6: {
    fontWeight: 600,
    fontSize: 14,
    letterSpacing: '-0.05px',
    lineHeight: 1.45,
    ...tabular
  },
  subtitle1: {
    fontWeight: 500,
    fontSize: 15,
    letterSpacing: 0
  },
  subtitle2: {
    fontWeight: 500,
    fontSize: 13,
    letterSpacing: 0
  },
  body1: {
    fontSize: 14,
    letterSpacing: 0,
    lineHeight: 1.55
  },
  body2: {
    fontSize: 13,
    letterSpacing: 0,
    lineHeight: 1.5
  },
  caption: {
    fontSize: 11.5,
    letterSpacing: '0.1px',
    ...tabular
  },
  // Was letterspaced uppercase, which is one of the tells that dates the UI.
  // Labels now read as sentence case at a normal tracking.
  overline: {
    fontWeight: 600,
    fontSize: 11,
    letterSpacing: '0.2px',
    textTransform: 'none' as const,
    lineHeight: 1.5
  },
  button: {
    fontWeight: 600,
    letterSpacing: '0.1px',
    textTransform: 'none' as const
  }
};
